import { create } from "zustand";

interface StoreState {
  data: string;
  setData: (value: string) => void;
}

export const useStore = create<StoreState>((set) => ({
  data: "",
  setData: (value: string) => set({ data: value }),
}));
